module.exports = {"id":"dp1_3l3q5","text":"Managing Information","instructions":"What is the primary function of basic spreadsheet formulas?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"1.3","questionType":"PickOne","random":true,"options":[{"id":"dp1_3l3q5-a1","text":"To calculate and transform data","score":3.7},{"id":"dp1_3l3q5-a2","text":"To change visual formatting","score":1.3},{"id":"dp1_3l3q5-a3","text":"To encrypt spreadsheet files","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.3/l3q5.json
// module id = 975
// module chunks = 41